module.exports = __webpack_public_path__ + "img/TG11X5.png";